import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import ZywaveGroupProfile from 'components/zywave-group-info';
import ZywaveGroupInfoPageStore, {
  ZywaveGroupInfoPageStoreContext,
} from 'store/pages/zywave-group-info/zywaveGroupInfoPageStore';

const ZywaveGroupInfoPage: React.FC = observer(() => {
  const store = useMemo(() => new ZywaveGroupInfoPageStore(), []);

  return (
    <ZywaveGroupInfoPageStoreContext.Provider value={store}>
      <ZywaveGroupProfile />
    </ZywaveGroupInfoPageStoreContext.Provider>
  );
});

export default ZywaveGroupInfoPage;
